export enum Traits {
  SendPrescriptionsToRX = 1,
  BlockUsersFromManuallyAddingToVisit = 2,
  DisallowRemovalFromVisit = 3,
  HeartwormProtection = 4,
  FleaTickProtection = 5,
  AllowDecline = 6,
  MinimumWeight = 7,
  MaximumWeight = 8,
  IDEXXHeadlessOrder = 9,
  IDEXXOrder = 10,
  ReservationPreConfirmed = 11,
  ReservationOverbooked = 12,
  ReservationWalkIn = 13,
  SendLabResultstoPetParent = 14,
  IDEXXInHouseTest = 15,
  IsEuthanasia = 16,
  IsSpayNeuter = 17,
  IsControlled = 18,
  BarcodeNotRequired = 19,
  IsAnesthesiaMedication = 20,
  IncludeInWellnessSummary = 21,
  AllowedInPnpNewOrder = 22,
  DefaultQuantity = 24,
  DefaultRefills = 25,
  IsExam = 26,
  AllowCustomRemindersVaccines = 27,
  AllowCustomRemindersNonVaccines = 28,
  RepeatDelivery = 29,
  HospitalFleaTickMedication = 30,
  HospitalHeartwormMedication = 31,
  HospitalHeartwormFleaTickComboMedication = 32,
  ClinicFleaTickMedication = 33,
  ClinicHeartwormMedication = 34,
  ClinicHeartwormFleaTickComboMedication = 35,
  AllowPrescribeOnly = 36,
  Vaccination = 37,
}
